//imports
import {
    KEYSFOBS_CREATE_EDIT_OPEN_MODAL,
    KEYSFOBS_GET_KEYFOB_REQUEST,
    KEYSFOBS_GET_KEYFOB_RESULT,
    KEYSFOBS_CREATE_REQUEST,
    KEYSFOBS_CREATE_RESULT,
    KEYSFOBS_UPDATE_REQUEST,
    KEYSFOBS_UPDATE_RESULT,
    KEYSFOBS_GET_DRIVER_REQUEST,
    KEYSFOBS_GET_DRIVER_RESULT,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

//initial values
const INIT_STATE = {
    openModal: false,
    loading: false,
    create: null,
    update: null,
    delete: null,
    currentId: null,
    keyfob: null,
    drivers: [],
};


//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case KEYSFOBS_GET_DRIVER_REQUEST:
            return { ...state, loading: true }

        case KEYSFOBS_GET_DRIVER_RESULT:
            return { ...state, loading: false, drivers: action.payload }

        case KEYSFOBS_CREATE_EDIT_OPEN_MODAL:
            return { ...state, openModal: true, currentId: action.payload }

        case KEYSFOBS_CREATE_REQUEST:
            return { ...state, loading: true }

        case KEYSFOBS_CREATE_RESULT:
            return { ...state, loading: false, create: action.payload }

        case KEYSFOBS_UPDATE_REQUEST:
            return { ...state, loading: true }

        case KEYSFOBS_UPDATE_RESULT:
            return { ...state, loading: false, update: action.payload }

        case KEYSFOBS_GET_KEYFOB_REQUEST:
            return { ...state, loading: true }

        case KEYSFOBS_GET_KEYFOB_RESULT:
            return { ...state, loading: false, keyfob: action.payload }

        case CLEAR_REDUX:
            return ["", "KEYFOBS_CREATE_EDIT"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};